module.exports = __webpack_public_path__ + "8ccf26f244f28ecf8ce61ece23451380.pdf";